// DO NOT EDIT — generated by Terrazzo from tokens/colors.tokens.json
// Run `npm run tokens` to regenerate.

export const colors = {
  alertColor: "#d85c47",
  altBlack: "#383838",
  altDark: "#5f6368",
  altGray: "#bdbdbd",
  altGreen: "#0b5240",
  altWhite: "#fefefe",
  barChartDark: "#0b5420",
  barChartLight: "#91c684",
  bgColor: "#e2e2e2",
  borderColor: "#3e3e3e",
  darkBlue: "#255792",
  darkGreen: "#083f31",
  dividerGray: "#0000001f",
  exploreBgColor: "#f1f4f8",
  footerColor: "#edf3f0",
  grayGridColorDarker: "#dddddd",
  groupGreen: "#7db640",
  groupYellowGreen: "#b9ce3a",
  hexShareIconGray: "#757575",
  hoverAltGreen: "rgba(11, 82, 64, 0.08)",
  howToColor: "#bdc1c6",
  infobarColor: "#f8e8b0",
  lightOutline: "rgba(0, 0, 0, 0.23)",
  mapDark: "#027e47",
  mapDarker: "#185e49",
  mapDarkest: "#134b3a",
  mapDarkZero: "#35403d",
  mapLight: "#7db640",
  mapLighter: "#b9ce3a",
  mapLightest: "#f2e62f",
  mapLightZero: "#fff9c1",
  mapMedicareDark: "#365c8d",
  mapMedicareDarkest: "#46327f",
  mapMedicareDarkZero: "#090121",
  mapMedicareEvenLighter: "#9fda3a",
  mapMedicareLight: "#1fa187",
  mapMedicareLighter: "#4bc16c",
  mapMedicareLightest: "#f0e525",
  mapMedicareLightZero: "#fff9c1",
  mapMedicareMid: "#267f8e",
  mapMenDark: "#65156e",
  mapMenDarker: "#280b54",
  mapMenLight: "#d44843",
  mapMenLighter: "#f57d15",
  mapMenLightest: "#fbc127",
  mapMenMid: "#9f2a63",
  mapMid: "#3e9b42",
  mapWomenDark: "#8b0aa5",
  mapWomenDarker: "#5402a3",
  mapWomenDarkest: "#320161",
  mapWomenDarkZero: "#120161",
  mapWomenLight: "#db5b68",
  mapWomenLighter: "#f48849",
  mapWomenLightest: "#febc2b",
  mapWomenLightZero: "#f3e221",
  mapWomenMid: "#b93389",
  mapYouthDark: "#c34e27",
  mapYouthDarker: "#a33a2b",
  mapYouthDarkest: "#772f2a",
  mapYouthDarkZero: "#5a2f2a",
  mapYouthLight: "#e87b26",
  mapYouthLighter: "#f09726",
  mapYouthLightest: "#f4b02a",
  mapYouthLightZero: "#f7d136",
  mapYouthMid: "#e06226",
  methodologyGreen: "#b5c7c2",
  navlinkColor: "#202124",
  redOrange: "#ed573f",
  reportAlert: "#ff9800",
  secondaryDark: "#167b6f",
  secondaryLight: "#89d5cc",
  secondaryMain: "#228b7e",
  standardInfo: "#f8f9fa",
  standardWarning: "#fff8eb",
  timberwolf: "#cbd0c8",
  timeCyanBlue: "#79b4b7",
  timeDarkRed: "#8c0000",
  timePastelGreen: "#547d6b",
  timePink: "#ff85b3",
  timePurple: "#816d98",
  timeYellow: "#fcb431",
  tinyTagGray: "rgba(220, 229, 226, 0.18)",
  toggleColor: "#e1e9e7",
  transparent: "#00000000",
  unknownMapLeast: "#d3eece",
  unknownMapLess: "#92d4be",
  unknownMapLesser: "#b8e3be",
  unknownMapMid: "#60bccb",
  unknownMapMore: "#47a8cb",
  unknownMapMost: "#0b61a2",
  whiteSmoke: "rgba(240, 241, 239, 0.8)",
} as const

export type ColorsKey = keyof typeof colors
